<template>
  <div v-if="shouldShow" class="form-field-wrapper">
    <div v-if="data?.label" class="field-label">
      {{ data.label }}
      <span v-if="data?.required" class="required-mark">*</span>
    </div>
    <div v-if="data?.description" class="field-description" v-html="data.description"></div>
    <div class="field-input">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormFieldWrapper',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    shouldShow() {
      // Show if label or description exists
      return this.data?.label || this.data?.description;
    }
  }
};
</script>

<style scoped>
.form-field-wrapper {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-label {
  color: #333;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
}

.required-mark {
  color: #D32F2F;
  margin-left: 2px;
}

.field-description {
  color: #666;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  white-space: pre-wrap;
  word-wrap: break-word;
}

/* Rich text styles in description */
.field-description ul,
.field-description ol {
  margin: 0;
  padding-left: 0;
  list-style: none;
  counter-reset: item;
}

.field-description li {
  margin: 0;
  padding-left: 21px;
  position: relative;
}

.field-description ul > li::before {
  content: "• ";
  position: absolute;
  left: 6px;
}

.field-description ol {
  counter-reset: item;
}

.field-description ol > li {
  counter-increment: item;
}

.field-description ol > li::before {
  content: counter(item) ". ";
  position: absolute;
  left: 0;
}

.field-description strong,
.field-description b {
  font-weight: 700;
}

.field-description em,
.field-description i {
  font-style: italic;
}

.field-description u {
  text-decoration: underline;
}

.field-input {
  width: 100%;
}
</style>
